import React, { lazy } from 'react'
import { Router, Route, Switch } from 'react-router-dom'
import { ResetCSS } from 'uikit'
import BigNumber from 'bignumber.js'
import useEagerConnect from 'hooks/useEagerConnect'
import {
  usePollBlockNumber,
  usePollFarmsData,
  usePollVaultsData,
  useFetchPublicMultiPoolData,
  useFetchSeriesesData,
} from 'state/hooks'
import { DatePickerPortal } from 'components/DatePicker'
import GlobalStyle from './style/Global'
import Menu from './components/Menu'
import SuspenseWithChunkError from './components/SuspenseWithChunkError'
import { ToastListener } from './contexts/ToastsContext'
import PageLoader from './components/PageLoader'
import EasterEgg from './components/EasterEgg'
import Pools from './views/Pools'
import MultiPool from './views/MultiPool'
import { Stats } from './views/Home'
import Swap from './views/Swap'
import { RedirectToSwap } from './views/Swap/redirects'
import history from './routerHistory'

// Route-based code splitting
// Only pool is included in the main bundle because of it's the most visited page
const Home = lazy(() => import('./views/Home'))
const Burn = lazy(() => import('./views/Burn'))
const Wheel = lazy(() => import('./views/Wheel'))
// const Exchange = lazy(() => import('./views/Exchange'))
const Zap = lazy(() => import('./views/Zap'))
const Farms = lazy(() => import('./views/Farms'))
const Nft = lazy(() => import('./views/Nft'))
// const PreSale = lazy(() => import('./views/PreSale'))
const Vaults = lazy(() => import('./views/Vaults'))
// const Ifos = lazy(() => import('./views/Ifos'))
const NotFound = lazy(() => import('./views/NotFound'))
// const Voting = lazy(() => import('./views/Voting'))

// This config is required for number formatting
BigNumber.config({
  EXPONENTIAL_AT: 1000,
  DECIMAL_PLACES: 80,
})

const App: React.FC = () => {
  usePollBlockNumber()
  useEagerConnect()
  usePollFarmsData()
  usePollVaultsData()
  useFetchPublicMultiPoolData()
  useFetchSeriesesData()

  return (
    <Router history={history}>
      <ResetCSS />
      <GlobalStyle />
      <Menu>
        <SuspenseWithChunkError fallback={<PageLoader />}>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            {/* <Route path="/exchange">
              <Exchange />
            </Route> */}
            <Route path="/zap">
              <Zap />
            </Route>
            <Route path="/nft">
              <Nft />
            </Route>
            <Route path="/farms">
              <Farms />
            </Route>
            <Route path="/pools">
              <Pools />
            </Route>
            <Route path="/multi-pool">
              <MultiPool />
            </Route>
            <Route path="/vaults">
              <Vaults />
            </Route>
            <Route path="/burn">
              <Burn />
            </Route>
            <Route path="/wheel">
              <Wheel />
            </Route>
            <Route path="/stats">
              <Stats />
            </Route>
            {/* Using this format because these components use routes injected props. We need to rework them with hooks */}
            <Route exact strict path="/swap" component={Swap} />
            <Route exact strict path="/swap/:outputCurrency" component={RedirectToSwap} />
            {/* <Route path="/presale">
              <PreSale />
            </Route> */}
            {/* 404 */}
            <Route component={NotFound} />
          </Switch>
        </SuspenseWithChunkError>
      </Menu>
      <EasterEgg iterations={2} />
      <ToastListener />
      <DatePickerPortal />
    </Router>
  )
}

export default React.memo(App)
